import { useApi } from '@api/ApiProvider'
import type { ReportInput } from '@api/endpoints'
import { getAnonymousId } from '@lib/anonymous-id'
import { resizeImage } from '@lib/resize-image'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export type ReportDraft = Omit<ReportInput, 'anonymousId'>

// Enviar un aviso: reduce la foto en el navegador, añade el identificador anónimo y, al
// terminar, invalida la ficha y el mapa para que muestren el estado nuevo.
export const useReportTree = (code: string) => {
	const api = useApi()
	const queryClient = useQueryClient()
	return useMutation({
		mutationFn: async (draft: ReportDraft) =>
			api.reportTree(code, {
				...draft,
				photo: draft.photo ? await resizeImage(draft.photo) : null,
				anonymousId: getAnonymousId(),
			}),
		onSuccess: async () => {
			await queryClient.invalidateQueries({ queryKey: ['tree', code.toUpperCase()] })
			await queryClient.invalidateQueries({ queryKey: ['trees'] })
		},
	})
}
